import { Github, GitBranch, GitPullRequest, CircleDot, BookMarked } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { githubWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  githubWeb,
  {
    GitHubAppSetupPage: () => import('./GitHubAppSetupPage'),
    GitHubAppAdminSetupPanel: () => import('./GitHubAppAdminSetupPanel'),
    GitRepoAttachmentPicker: () => import('./GitRepoAttachmentPicker'),
    GitRepoAttachmentSummary: () => import('./GitRepoAttachmentSummary'),
    GitRepoMentionProvider: () => import('./GitRepoMentionProvider'),
    GitHubPrContextProvider: () => import('./GitHubPrContextProvider'),
    GitHubIssueContextProvider: () => import('./GitHubIssueContextProvider'),
    GitHubRepoContextProvider: () => import('./GitHubRepoContextProvider'),
    GitHubBranchContextProvider: () => import('./GitHubBranchContextProvider'),
    GitHubPrLinkBadge: () => import('./GitHubPrLinkBadge'),
    GitHubPrMentionBadge: () => import('./GitHubPrMentionBadge'),
  },
  {
    icons: { Github, GitBranch, GitPullRequest, CircleDot, BookMarked },
  },
);
